import { useLocation } from 'react-router';
import { RouterConfigType, Type } from '@edikk-edikk/shared';
import loadable from '@loadable/component';
import { ContentLoader } from '@edikk-edikk/country-common';
import { useBaseContext } from '#base/hooks/use-base-context';

const List = loadable(() => import('#advertList/containers/List'), {
  fallback: <ContentLoader />,
});
const AdvertDetailWrapper = loadable(() => import('#advertDetail/containers/AdvertDetail'), {
  fallback: <ContentLoader />,
  resolveComponent: ({ AdvertDetail: Component }) => Component,
});
const ReviewList = loadable(() => import('#reviewList/containers/ReviewList'), {
  fallback: <ContentLoader />,
});
const PageContainer = loadable(() => import('#page/containers'), {
  fallback: <ContentLoader />,
  resolveComponent: ({ PageContainer: Component }) => Component,
});

const DynamicPages = () => {
  const { state } = useLocation();
  const routerConfigFromLocationState: RouterConfigType = state?.routerConfig ?? null;
  const { routerConfig: routerConfigFromBaseState } = useBaseContext();

  if (!routerConfigFromLocationState && !routerConfigFromBaseState) {
    return null;
  }

  const routerConfig = routerConfigFromLocationState ?? routerConfigFromBaseState;

  if (
    routerConfig.type === Type.category
    || routerConfig.type === Type.city
    || routerConfig.type === Type.region
    || routerConfig.type === Type.categoryInCity
    || routerConfig.type === Type.area
  ) {
    return <List categoryId={routerConfig.categoryId} cityId={routerConfig.cityId} areaId={routerConfig.areaId} />;
  }

  if (routerConfig.type === Type.advertDetail) {
    return <AdvertDetailWrapper id={routerConfig.advertId} />;
  }

  if (routerConfig.type === Type.reviewListInCity) {
    return <ReviewList cityId={routerConfig.cityId} />;
  }

  if (routerConfig.type === Type.page) {
    return <PageContainer id={routerConfig.pageId} />;
  }

  throw new Error(`Router not found. Type: ${routerConfig.type}`);
};

export { DynamicPages };
